import { gql, useQuery } from '@apollo/client'

const GET_FAVORITE_BOOKIE_FLAG = gql`
  query GetTenantConfigFavoriteBookie {
    tenantConfig {
      featureFlags {
        key
        enabled
      }
    }
  }
`

interface FavoriteBookieConfig {
  loading: boolean
  enabled: boolean
}

/**
 * Returns whether the current tenant has the favorite_bookie feature enabled,
 * driven by the `favorite_bookie` flag in the `feature_flags` table.
 */
export function useFavoriteBookieEnabled(): FavoriteBookieConfig {
  const { data, loading } = useQuery(GET_FAVORITE_BOOKIE_FLAG, { fetchPolicy: 'cache-first' })

  const flags: Array<{ key: string; enabled: boolean }> = data?.tenantConfig?.featureFlags ?? []
  const flag = flags.find(f => f.key === 'favorite_bookie')

  return {
    loading,
    enabled: flag?.enabled ?? false,
  }
}
